// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity_block_line-module__value--VgwB-{font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px}.entity_block_line-module__hover--2S6hs{color:#36b}\n", ""]);
// Exports
exports.locals = {
	"value": "entity_block_line-module__value--VgwB-",
	"hover": "entity_block_line-module__hover--2S6hs"
};
module.exports = exports;
